import {CentralContent} from "../../../components/central-content/CentralContent";
import {SignUpWithEmailForm} from "../../../components/sign-up/SignUpWithEmailForm";
import {Page} from "../../Page";

export const EmailSignUpPage = () => {
  return (
      <Page>
        <CentralContent>
          <SignUpWithEmailForm />
        </CentralContent>
      </Page>
  );
}